import { IMinUserWithCanBeRemovedProp } from "@mctypes/global.types";
import { Box, Group, Text } from "@mantine/core";
import React from "react";
import { Avatar } from "..";

const UserList: React.FC<{
  addedUsers: IMinUserWithCanBeRemovedProp[];
  condensed?: boolean;
}> = ({ addedUsers, condensed = false }) => {
  return (
    <Box style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      {addedUsers.map((user, i) => {
        return (
          <Box key={i} className="mb-0">
            <Box
              className="d-flex titleWithDelete"
              style={{ height: `${condensed === true ? "30px" : "auto"}` }}
            >
              <Group gap={6} wrap="nowrap">
                <Avatar id={user._id} name={user.name} size={condensed === true ? 20 : 24} />
                <Text size={condensed === true ? "xs" : "sm"} className="two-line-text-truncate">
                  {user.name}
                </Text>
              </Group>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default UserList;
